import { Provider, EnvironmentProviders, InjectionToken } from "@angular/core";
import { Configuration as PurpleFitConfiguration } from "../core-modules/sdk";
import { PurpleApiTokenService } from "@purple-lib/purple-api-token";

export function providePurpleFitCore(apiPath: string): (Provider | EnvironmentProviders)[] {
  return [
    addProviderConfiguration(apiPath),
    providerOptions({
      apiPath: apiPath
    })
  ]
}

function addProviderConfiguration(apiPath: string): Provider | EnvironmentProviders {
  return {
    provide: PurpleFitConfiguration,
    useFactory: (tokenSvc: PurpleApiTokenService) => new PurpleFitConfiguration(
      {
        basePath: apiPath,
        credentials: { "Bearer": () => tokenSvc.getToken("mainToken") }
      }
    ),
    deps: [PurpleApiTokenService],
    multi: false
  };
}



function providerOptions(options: PurpleFitServiceOptions): Provider | EnvironmentProviders {
  return {
    provide: PURPLE_FIT_SERVICE_OPTIONS,
    useValue: {
      apiPath: options.apiPath
    },
    multi: false
  };
}

export interface PurpleFitServiceOptions {
  apiPath: string;
}

export const PURPLE_FIT_SERVICE_OPTIONS:
  InjectionToken<PurpleFitServiceOptions> =
  new InjectionToken<PurpleFitServiceOptions>('PURPLEFITSERVICEOPTIONS');